const devConfig = {
    "PORT": 8080,
    "BASE_URL": "https://ifincredit-dev.ifingate.com",
    "REACT_APP_API_URL": "https://ifincredit-api-dev.ifingate.com",
    "APP_IFINGATE": "https://dev.ifingate.com",
}

export default devConfig;
